import React from 'react';
import SnowParticles from './SnowParticles';

const BG_URL = '/Background_frostbound.png';

export default function PageWrapper({ children, scrollable = false }) {
  return (
    <div className={`frostbound-root ${scrollable ? 'frostbound-scrollable' : ''}`}>
      <div
        className={`hero-bg ${scrollable ? 'hero-bg--fixed' : ''}`}
        style={{ backgroundImage: `url('${BG_URL}')` }}
      />
      <div className="overlay-dark" />
      <div className="overlay-blue" />
      <div className="overlay-vignette" />
      <div className="overlay-glow-center" />
      <SnowParticles />
      <div className={`layout-wrapper ${scrollable ? 'layout-wrapper--scroll' : ''}`}>
        {children}
      </div>
    </div>
  );
}
